import { Component, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { datePickerValidator } from '@app/core/Directives/datepicker-validator';
import { MaxLength, NotificationTextMessage } from '@app/core/Enum';
import { GlobalComponent, SideListModel } from '@app/core/Models';
import { CommonService } from '@app/core/Services';
import { HighlightRow } from '@app/core/Services/common/highlighted-texts.service';
import { FundTransferState, GetBanksByFundID, GetTransferToFund } from '@app/core/Store';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-add-fund-transfer',
  templateUrl: './add-fund-transfer.component.html',
  styleUrls: ['./add-fund-transfer.component.scss'],
})
export class AddFundTransferComponent implements OnInit {
  fundToTransList: SideListModel[];
  tempfundToTransList: SideListModel[];

  fundfromTransList: SideListModel[];
  tempfundfromTransList: SideListModel[];

  fundTransferForm: FormGroup;

  @Input() triggerEditData: Observable<any>;
  @Input() moduleId: number;
  notificationMessage = NotificationTextMessage;
  maxLength = MaxLength;

  periodicDate: any;

  minInvoiceDate: Date;
  maxInvoiceDate: Date = new Date();

  constructor(
    private store: Store,
    private globalComponent: GlobalComponent,
    public commonService: CommonService,
    public highlightRow: HighlightRow
  ) {}

  ngOnInit(): void {
    this.periodicDate = this.globalComponent.getFinancialPeriod();
    this.setForm();
    this.getTransferToFund();

    this.triggerEditData?.subscribe((data) => {
      this.editFundTransfer(data);
    });

    this.fundTransferForm.valueChanges.subscribe((value) => {
      this.commonService.isInitialValueChange = this.fundTransferForm.touched;
    });
    this.setInvoiceDateLimits();
  }

  editFundTransfer(data): void {
    this.fundTransferForm.patchValue({
      transferFrom: data.fromFundId,
      transferDate: data.transferDate,
      transferTo: data.toFundId,
      amount: data.amount,
      note: data.note,
      transferFromBank: data.fromBankId,
      transferToBank: data.toBankId,
    });
    this.getFromBanksByFundId(data.fromBankId);
    this.getToBanksByFundId(data.toBankId);
  }

  setForm(): void {
    this.fundTransferForm = new FormGroup(
      {
        transferFrom: new FormControl('', [
          Validators.required,
          this.commonService.whiteSpaceValidate,
        ]),
        transferDate: new FormControl(
          new Date(),
          datePickerValidator(this.periodicDate)
        ),
        transferTo: new FormControl('', [
          Validators.required,
          this.commonService.whiteSpaceValidate,
        ]),
        amount: new FormControl(''),
        note: new FormControl(''),
        transferFromBank: new FormControl(''),
        transferToBank: new FormControl(''),
      },
      {
        validators: this.commonService.compareFields(
          'transferFrom',
          'transferTo',
          this.moduleId
        ),
      }
    );
  }

  getTransferToFund(): void {
    this.store
      .dispatch(new GetTransferToFund())
      .pipe(
        tap(() => {
          this.fundToTransList = this.tempfundToTransList =
            this.store.selectSnapshot(FundTransferState.getTransferToFund)!;

          this.fundfromTransList = this.tempfundfromTransList =
            this.store.selectSnapshot(FundTransferState.getTransferToFund)!;
        })
      )
      .subscribe();
  }
  fromBankData:any=[];
  getFromBanksByFundId(id?:any): void {
    this.store
      .dispatch(new GetBanksByFundID(this.fundTransferForm.controls.transferFrom.value))
      .pipe(
       
      )
      .subscribe((res) => {
        this.fromBankData=res.bankTransfer.fromBankData;
        if(id){
          this.fundTransferForm.controls.transferFromBank.setValue(id);
        }
      });
  }

  toBankData:any=[];
  getToBanksByFundId(id?:any): void {
    this.store
      .dispatch(new GetBanksByFundID(this.fundTransferForm.controls.transferTo.value))
      .pipe(
       
      )
      .subscribe((res) => {
        this.toBankData=res.bankTransfer.fromBankData;
        if(id){
          this.fundTransferForm.controls.transferToBank.setValue(id);
        }
      });
  }

  setInvoiceDateLimits(): void {
    if (this.periodicDate?.length > 0) {
      const unlockedPeriod = this.periodicDate.find(
        (period: any) => !period.isLocked
      );

      if (unlockedPeriod) {
        this.minInvoiceDate = new Date(unlockedPeriod.fromDate);
      } else {
        this.minInvoiceDate = new Date(this.periodicDate[0].fromDate);
      }

      this.maxInvoiceDate = new Date(
        this.periodicDate[this.periodicDate.length - 1]?.toDate
      );
    }
  }
}
